export default {
  xeroContacts: [],
  xeroClients: [],
  xeroSuppliers: [],
  xeroContact: undefined,
};
